import * as React from 'react';

function SvgEmailFilled(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.377 4H4.047l5.768 4.517a.25.25 0 00.308-.008L15.378 4zM3 5.085V15a1 1 0 001 1h12a1 1 0 001-1V5a.997.997 0 00-.066-.36L11.08 9.665a1.75 1.75 0 01-2.154.061L3 5.085z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgEmailFilled;
